// tslint:disable
/**
 * respondeco.org
 * API description of respondeco.org
 *
 * The version of the OpenAPI document: 1.2.5
 * Contact: klaus@respondeco.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
  import {
    OfferPageResponse,
    OfferPageResponseFromJSON,
    OfferPageResponseToJSON,
    OrganisationActivitiesPageResponse,
    OrganisationActivitiesPageResponseFromJSON,
    OrganisationActivitiesPageResponseToJSON,
    OrganisationInteractionsPageResponse,
    OrganisationInteractionsPageResponseFromJSON,
    OrganisationInteractionsPageResponseToJSON,
    OrganisationPageResponse,
    OrganisationPageResponseFromJSON,
    OrganisationPageResponseToJSON,
    OrganisationRequest,
    OrganisationRequestFromJSON,
    OrganisationRequestToJSON,
    OrganisationResponse,
    OrganisationResponseFromJSON,
    OrganisationResponseToJSON,
    PostPageResponse,
    PostPageResponseFromJSON,
    PostPageResponseToJSON,
    PostRequest,
    PostRequestFromJSON,
    PostRequestToJSON,
    PostResponse,
    PostResponseFromJSON,
    PostResponseToJSON,
    ProjectPageResponse,
    ProjectPageResponseFromJSON,
    ProjectPageResponseToJSON,
    StatisticsResponse,
    StatisticsResponseFromJSON,
    StatisticsResponseToJSON,
  } from '../models';

      export interface CreateOrganisationPostRequest {
        organisationId: number;
        postRequest?: PostRequest;
      }

      export interface GetOffersOfOrganisationRequest {
        organisationId: number;
        page?: number;
        pageSize?: number;
      }

      export interface GetOrganisationRequest {
        organisationId: number;
      }

      export interface GetOrganisationActivitiesRequest {
        organisationId: number;
        pageSize?: number;
        page?: number;
      }

      export interface GetOrganisationInteractionsRequest {
        organisationId: number;
        pageSize?: number;
        page?: number;
      }

      export interface GetOrganisationPostsRequest {
        organisationId: number;
        pageSize?: number;
        page?: number;
      }

      export interface GetOrganisationsRequest {
        pageSize?: number;
        page?: number;
        project?: string;
        query?: string;
        categories?: Array<number>;
        organisationTypes?: Array<number>;
      }

      export interface GetProjectsOfOrganisationRequest {
        organisationId: number;
        includePartnerProjects?: boolean;
        page?: number;
        pageSize?: number;
      }

      export interface GetStatisticsForOrganisationRequest {
        organisationId: number;
      }

      export interface UpdateOrganisationRequest {
        organisationId: number;
        organisation?: OrganisationRequest;
        file?: Blob;
      }


/**
* no description
*/
export interface OrganisationsApi {
    /**
      * Create a new post
    */
    createOrganisationPost(requestParameters: CreateOrganisationPostRequest): Promise<PostResponse>
    /**
      * List of offers for a specific organisation (includes offers that the organisation participated with)
    */
    getOffersOfOrganisation(requestParameters: GetOffersOfOrganisationRequest): Promise<OfferPageResponse>
    /**
      * Represents an organisation
    */
    getOrganisation(requestParameters: GetOrganisationRequest): Promise<OrganisationResponse>
    /**
      * Page of activities.
    */
    getOrganisationActivities(requestParameters: GetOrganisationActivitiesRequest): Promise<OrganisationActivitiesPageResponse>
    /**
      * Page of interactions.
    */
    getOrganisationInteractions(requestParameters: GetOrganisationInteractionsRequest): Promise<OrganisationInteractionsPageResponse>
    /**
      * Get a list of posts for the given organisation.
    */
    getOrganisationPosts(requestParameters: GetOrganisationPostsRequest): Promise<PostPageResponse>
    /**
      * Paged list of organisations
    */
    getOrganisations(requestParameters: GetOrganisationsRequest): Promise<OrganisationPageResponse>
    /**
      * List of projects for a specific organisation (includes projects that the organisation participated with)
    */
    getProjectsOfOrganisation(requestParameters: GetProjectsOfOrganisationRequest): Promise<ProjectPageResponse>
    /**
      * Statistics for the given organisation
    */
    getStatisticsForOrganisation(requestParameters: GetStatisticsForOrganisationRequest): Promise<StatisticsResponse>
    /**
      * Update an organisation
    */
    updateOrganisation(requestParameters: UpdateOrganisationRequest): Promise<OrganisationResponse>
}

  /**
  * no description
  */
  export class OrganisationsApiImpl extends runtime.BaseAPI implements OrganisationsApi {

    /**
      * Create a new post
    */
    async createOrganisationPostRaw(requestParameters: CreateOrganisationPostRequest): Promise<runtime.ApiResponse<PostResponse>> {
          if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
          throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling createOrganisationPost.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/organisations/{organisationId}/posts`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))),
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: PostRequestToJSON(requestParameters.postRequest),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => PostResponseFromJSON(jsonValue));
      }

      /**
        * Create a new post
      */
      async createOrganisationPost(requestParameters: CreateOrganisationPostRequest): Promise<PostResponse> {
        const response = await this.createOrganisationPostRaw(requestParameters);
        return await response.value();
      }

    /**
      * List of offers for a specific organisation (includes offers that the organisation participated with)
    */
    async getOffersOfOrganisationRaw(requestParameters: GetOffersOfOrganisationRequest): Promise<runtime.ApiResponse<OfferPageResponse>> {
          if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
          throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling getOffersOfOrganisation.');
          }

      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/organisations/{organisationId}/offers`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => OfferPageResponseFromJSON(jsonValue));
      }

      /**
        * List of offers for a specific organisation (includes offers that the organisation participated with)
      */
      async getOffersOfOrganisation(requestParameters: GetOffersOfOrganisationRequest): Promise<OfferPageResponse> {
        const response = await this.getOffersOfOrganisationRaw(requestParameters);
        return await response.value();
      }

    /**
      * Represents an organisation
    */
    async getOrganisationRaw(requestParameters: GetOrganisationRequest): Promise<runtime.ApiResponse<OrganisationResponse>> {
          if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
          throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling getOrganisation.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/organisations/{organisationId}`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationResponseFromJSON(jsonValue));
      }

      /**
        * Represents an organisation
      */
      async getOrganisation(requestParameters: GetOrganisationRequest): Promise<OrganisationResponse> {
        const response = await this.getOrganisationRaw(requestParameters);
        return await response.value();
      }

    /**
      * Page of activities.
    */
    async getOrganisationActivitiesRaw(requestParameters: GetOrganisationActivitiesRequest): Promise<runtime.ApiResponse<OrganisationActivitiesPageResponse>> {
          if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
          throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling getOrganisationActivities.');
          }

      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/organisations/{organisationId}/activities`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationActivitiesPageResponseFromJSON(jsonValue));
      }

      /**
        * Page of activities.
      */
      async getOrganisationActivities(requestParameters: GetOrganisationActivitiesRequest): Promise<OrganisationActivitiesPageResponse> {
        const response = await this.getOrganisationActivitiesRaw(requestParameters);
        return await response.value();
      }

    /**
      * Page of interactions.
    */
    async getOrganisationInteractionsRaw(requestParameters: GetOrganisationInteractionsRequest): Promise<runtime.ApiResponse<OrganisationInteractionsPageResponse>> {
          if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
          throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling getOrganisationInteractions.');
          }

      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/organisations/{organisationId}/interactions`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationInteractionsPageResponseFromJSON(jsonValue));
      }

      /**
        * Page of interactions.
      */
      async getOrganisationInteractions(requestParameters: GetOrganisationInteractionsRequest): Promise<OrganisationInteractionsPageResponse> {
        const response = await this.getOrganisationInteractionsRaw(requestParameters);
        return await response.value();
      }

    /**
      * Get a list of posts for the given organisation.
    */
    async getOrganisationPostsRaw(requestParameters: GetOrganisationPostsRequest): Promise<runtime.ApiResponse<PostPageResponse>> {
          if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
          throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling getOrganisationPosts.');
          }

      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/organisations/{organisationId}/posts`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => PostPageResponseFromJSON(jsonValue));
      }

      /**
        * Get a list of posts for the given organisation.
      */
      async getOrganisationPosts(requestParameters: GetOrganisationPostsRequest): Promise<PostPageResponse> {
        const response = await this.getOrganisationPostsRaw(requestParameters);
        return await response.value();
      }

    /**
      * Paged list of organisations
    */
    async getOrganisationsRaw(requestParameters: GetOrganisationsRequest): Promise<runtime.ApiResponse<OrganisationPageResponse>> {
      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

          if (requestParameters.project !== undefined) {
              queryParameters['project'] = requestParameters.project;
          }

          if (requestParameters.query !== undefined) {
              queryParameters['query'] = requestParameters.query;
          }

          if (requestParameters.categories) {
            queryParameters['categories'] = requestParameters.categories;
          }

          if (requestParameters.organisationTypes) {
            queryParameters['organisationTypes'] = requestParameters.organisationTypes;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/organisations`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationPageResponseFromJSON(jsonValue));
      }

      /**
        * Paged list of organisations
      */
      async getOrganisations(requestParameters: GetOrganisationsRequest): Promise<OrganisationPageResponse> {
        const response = await this.getOrganisationsRaw(requestParameters);
        return await response.value();
      }

    /**
      * List of projects for a specific organisation (includes projects that the organisation participated with)
    */
    async getProjectsOfOrganisationRaw(requestParameters: GetProjectsOfOrganisationRequest): Promise<runtime.ApiResponse<ProjectPageResponse>> {
          if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
          throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling getProjectsOfOrganisation.');
          }

      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.includePartnerProjects !== undefined) {
              queryParameters['includePartnerProjects'] = requestParameters.includePartnerProjects;
          }

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/organisations/{organisationId}/projects`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => ProjectPageResponseFromJSON(jsonValue));
      }

      /**
        * List of projects for a specific organisation (includes projects that the organisation participated with)
      */
      async getProjectsOfOrganisation(requestParameters: GetProjectsOfOrganisationRequest): Promise<ProjectPageResponse> {
        const response = await this.getProjectsOfOrganisationRaw(requestParameters);
        return await response.value();
      }

    /**
      * Statistics for the given organisation
    */
    async getStatisticsForOrganisationRaw(requestParameters: GetStatisticsForOrganisationRequest): Promise<runtime.ApiResponse<StatisticsResponse>> {
          if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
          throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling getStatisticsForOrganisation.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/organisations/{organisationId}/statistics`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => StatisticsResponseFromJSON(jsonValue));
      }

      /**
        * Statistics for the given organisation
      */
      async getStatisticsForOrganisation(requestParameters: GetStatisticsForOrganisationRequest): Promise<StatisticsResponse> {
        const response = await this.getStatisticsForOrganisationRaw(requestParameters);
        return await response.value();
      }

    /**
      * Update an organisation
    */
    async updateOrganisationRaw(requestParameters: UpdateOrganisationRequest): Promise<runtime.ApiResponse<OrganisationResponse>> {
          if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
          throw new runtime.RequiredError('organisationId','Required parameter requestParameters.organisationId was null or undefined when calling updateOrganisation.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
        const formData = new FormData();
          if (requestParameters.organisation !== undefined) {
            formData.append('organisation', new Blob([JSON.stringify(requestParameters.organisation)], { type: 'application/json' }));
          }
            if (requestParameters.file !== undefined) {
              formData.append('file', requestParameters.file as any);
            }
      const response = await this.request({
      path: `/organisations/{organisationId}`.replace(`{${"organisationId"}}`, encodeURIComponent(String(requestParameters.organisationId))),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
        body: formData,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => OrganisationResponseFromJSON(jsonValue));
      }

      /**
        * Update an organisation
      */
      async updateOrganisation(requestParameters: UpdateOrganisationRequest): Promise<OrganisationResponse> {
        const response = await this.updateOrganisationRaw(requestParameters);
        return await response.value();
      }

    }
